import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  StreamEventStatusType
} from '../../../../api/stream/LiveStadiumStreamEvent';

import AbstractTableView from '../../../common/AbstractTableView';
import ListActionItems from '../../../List/ListActionItems';
import StreamStatus from './StreamStatus';
import { FormattedDate, FormattedTime } from 'react-intl';
// import { Tabs, Tab } from 'material-ui/Tabs';

import { TableRow, TableRowColumn, TableHeaderColumn } from 'material-ui/Table';

class StreamList extends AbstractTableView {
  static propTypes = {
    ...AbstractTableView.propTypes,
    // onChangeFilter: PropTypes.func.isRequired,
    displayStatus: PropTypes.bool.isRequired
  };

  defaultProps = {
    displayStatus: false
  };

  headerTitle = 'Stream List';
  confirmRemoveMessage = (
    <FormattedMessage
      id="record.remove"
      defaultMessage="Are you sure you want to delete stream event?"
    />
  );

  _viewStatusStream(status, type, startDate) {
    let now = new Date();
    if (type.finished === status || type.active === status || now > startDate) {
      return true;
    } else {
      return false;
    }
  }

  _renderHeader() {
    const { tableHeaderStyle, fixedHeaderStyle } = this.getStyles();
    let { displayStatus } = this.props;

    return (
      <TableRow>
        <TableHeaderColumn style={{ ...fixedHeaderStyle, minWidth: 200 }}>Name</TableHeaderColumn>
        {displayStatus ? (
          <TableHeaderColumn style={{ ...fixedHeaderStyle, textAlign: 'center' }}>Status</TableHeaderColumn>
        ) : null}
        <TableHeaderColumn style={tableHeaderStyle}>
          Start Time
        </TableHeaderColumn>
        <TableHeaderColumn style={tableHeaderStyle}>End Time</TableHeaderColumn>
        <TableHeaderColumn style={{ ...fixedHeaderStyle, width: 200}}>Actions</TableHeaderColumn>
      </TableRow>
    );
  }

  _renderContentItem(item, key) {
    let { title, channel_state, startDate, endDate } = item;
    let { displayStatus } = this.props;
    const { tableColumnStyle, fixedColumnStyle } = this.getStyles();

    return (
      <TableRow key={key}>
        <TableRowColumn style={{ ...fixedColumnStyle, minWidth: 200 }}>{title}</TableRowColumn>
        {displayStatus ? (
          <TableRowColumn style={{ ...fixedColumnStyle, textAlign: 'center' }}>
            <StreamStatus status={channel_state} />
          </TableRowColumn>
        ) : null}
        <TableRowColumn style={tableColumnStyle}>
          {this._renderFullTime(startDate)}
        </TableRowColumn>
        <TableRowColumn style={tableColumnStyle}>
          {this._renderFullTime(endDate)}
        </TableRowColumn>
        <TableRowColumn style={{ ...fixedColumnStyle, width: 200}}>
          <ListActionItems
            view={ this.props.view }
            edit={this.props.edit}
            remove={this.props.delete}
            record={item}
            published={this._viewStatusStream(
              status,
              StreamEventStatusType,
              startDate,
            )}
            confirmMessageLabel={this.confirmRemoveMessage}
          />
        </TableRowColumn>
      </TableRow>
    );
  }

  _renderFullTime(date) {
    return date ? (
      <span>
        <FormattedDate value={date} />{' '}
        <FormattedTime value={date} format="short" />
      </span>
    ) : (
      <span>-</span>
    );
  }
}

export default StreamList;



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamList/StreamList.jsx